import { render, staticRenderFns } from "./attention_requested_toggle.vue?vue&type=template&id=5cac6a85&"
import script from "./attention_requested_toggle.vue?vue&type=script&lang=js&"
export * from "./attention_requested_toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports